export enum DisponibiliteEtendu {
  AParaitre = "A Paraître",
  Disponible = "Disponible",
  Reimpressionencours = "Réimpression en cours",
  Manqueprovisoirement = "Manque provisoirement",
  ArretCommercialisation = "Arrêt de commercialisation",
  Epuise = "Epuisé",
  PlusDistribue = "Ne sera plus distribué",
  ManqueprovisoirementRouge= "Manque Provisoirement",
  Inconnu = ""
}

export function intToDisponibiliteEtendu(i: number | undefined): DisponibiliteEtendu {
  switch (i) {
    case 1: return DisponibiliteEtendu.Disponible
    case 2: return DisponibiliteEtendu.AParaitre
    case 3: return DisponibiliteEtendu.Reimpressionencours
    case 4: return DisponibiliteEtendu.Manqueprovisoirement
    case 5: return DisponibiliteEtendu.Epuise
    case 6: return DisponibiliteEtendu.ArretCommercialisation
    case 7: return DisponibiliteEtendu.PlusDistribue
    case 8: return DisponibiliteEtendu.ManqueprovisoirementRouge
    default: return DisponibiliteEtendu.Inconnu;// throw new Error("Valeur non valide pour la disponibilité");
  }
}